import SKILL_CHECK_AWS from '../../../../../public/next-image/skillCheck/aws.png';
import SKILL_CHECK_GITHUB from '../../../../../public/next-image/skillCheck/github.png';
import SKILL_CHECK_GOLANG from '../../../../../public/next-image/skillCheck/golang.png';
import SKILL_CHECK_NODE from '../../../../../public/next-image/skillCheck/node.js.png';
import SKILL_CHECK_PYTHON from '../../../../../public/next-image/skillCheck/python.png';
import SKILL_CHECK_REACT from '../../../../../public/next-image/skillCheck/react.png';
import SKILL_CHECK_SQL from '../../../../../public/next-image/skillCheck/sql.png';
import SKILL_CHECK_TYPESCRIPT from '../../../../../public/next-image/skillCheck/typescript.png';

export const getLogoImage = (category: string) => {
  switch (category) {
    case 'AWS': {
      return SKILL_CHECK_AWS;
    }

    case 'Git/GitHub': {
      return SKILL_CHECK_GITHUB;
    }

    case 'Go': {
      return SKILL_CHECK_GOLANG;
    }

    case 'Node.js': {
      return SKILL_CHECK_NODE;
    }

    case 'Python': {
      return SKILL_CHECK_PYTHON;
    }

    case 'React': {
      return SKILL_CHECK_REACT;
    }

    case 'SQL': {
      return SKILL_CHECK_SQL;
    }

    case 'TypeScript': {
      return SKILL_CHECK_TYPESCRIPT;
    }

    default: {
      return null;
    }
  }
};
